module.exports = __webpack_public_path__ + "static/media/stenobothrus_nigromaculatus.36b14383.jpg";